import { render, staticRenderFns } from "./LeerQR.vue?vue&type=template&id=50fac548&"
import script from "./LeerQR.vue?vue&type=script&lang=js&"
export * from "./LeerQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports